import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

export function buildAnswersPieOptions(correctCount, wrongCount) {
  return {
    chart: { backgroundColor: 'transparent', type: 'pie', height: 160 },
    title: { text: null },
    credits: { enabled: false },
    tooltip: { enabled: false },
    legend: { enabled: false },
    colors: ['#1CA388', '#FD6B62'],
    plotOptions: { pie: { size: '100%', dataLabels: { enabled: false } } },
    series: [
      {
        name: 'Respostas',
        data: [
          { name: 'Acertos', y: correctCount },
          { name: 'Erros', y: wrongCount }
        ]
      }
    ]
  };
}

// Pizza dinâmica de acertos/erros: a série é recalculada a cada render, então
// a fatia verde cresce e a vermelha encolhe (ou vice-versa) conforme o aluno responde.
export function AnswersPieChart({ correctCount, wrongCount }) {
  if (correctCount + wrongCount === 0) {
    return <p className="mb-0 py-6 text-center text-sm font-semibold text-neutral-400">Responda questões para ver o gráfico.</p>;
  }

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={buildAnswersPieOptions(correctCount, wrongCount)}
    />
  );
}
